export const revisarPresupuesto = (presupuesto, restante) => {
    let clase;

    if((presupuesto/4) > restante){
        clase = 'alert alert-danger';
    }else if((presupuesto/2) > restante){
        clase = 'alert alert-warning';
    }else{
        clase = 'alert alert-success';
    }

    return clase;
}


/*
    presupuesto = 400 y restante = 400
    400/4 = 100   >   400-350=80 : rojo
    400/2 = 200   >   400-220 =198 : amarrillo
*/